import React, { useReducer } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';

import Axios from 'axios';
import storage from '../../helpers/storage'
import loader from '../../helpers/loader'

import UserContext from './userContext';
import UserReducer from './userReducer';

import {
    GET_LOGGEDIN_USER,
    SET_USERTYPE,
    SET_IS_ADMIN,
    SET_IS_SUPER,
    SET_LOADING,
    UNSET_LOADING,
    SET_SIDEBAR,
    SET_USER,
    GET_BUSINESS,
    SET_NOTIFICATIONS,
    GET_KYB_DATA,
    GET_KYC_DATA,
    GET_VERIFICATION_DATA,
    GET_APIKEY,
    GET_DEVICES,
    SET_OWNER_ITEMS,
    SET_SIGNATORY_ITEMS,
    GET_STATES,
    GET_CITIES,
    GET_LGAS,
    GET_INDUSTRIES,
    GET_SUB_INDUSTRIES,
    GET_COUNTRIES
} from '../types'
import { IListQuery, IOwnerItem, ISignatoryItem } from '../../utils/types';
import { IOwnerItemChangeDTO } from '../../dtos/kybowner.dto';
import { ISignatoryItemChangeDTO } from '../../dtos/kybSignatory.dto';
import helperService from '../../utils/function';

const UserState = (props: any) => {

    const cookie = new Cookies();

    const exp = new Date(
        Date.now() + 70 * 24 * 60 * 60 * 1000
    )

    const navigate = useNavigate()
    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    const initialState = {
        user: {},
        userType: '',
        notifications: [],
        devices: [],
        ownerItems: [],
        signatoryItems: [],
        countries: [],
        states: [],
        cities: [],
        lgas: [],
        industries: [],
        subIndustries: [],
        ownerStates: [],
        ownerCities: [],
        ownerLgas: [],
        business: {},
        KYBData: {},
        KYCData: {},
        apikey: {},
        verification: {},
        isSuper: false,
        sidebar: {},
        isAdmin: false,
        loading: false,
        search: {
            error: false,
            message: '',
            data: []
        },
    }

    const [state, dispatch] = useReducer(UserReducer, initialState);

    const logout = async () => {

        storage.clearAuth();
        localStorage.clear();
        cookie.remove('token');
        cookie.remove('userType');

        navigate('/login');
        await Axios.post(`${process.env.REACT_APP_API_URL}/auth/logout`, {}, storage.getConfig());
    }

    const getUser = async (id: string) => {

        setLoading()

        await Axios.get(`${process.env.REACT_APP_API_URL}/auth/user/${id}`, storage.getConfigWithBearer())
            .then((resp) => {

                dispatch({
                    type: GET_LOGGEDIN_USER,
                    payload: resp.data.data
                });

                dispatch({
                    type: GET_VERIFICATION_DATA,
                    payload: resp.data.data.verification
                });

                cookie.set("userType", resp.data.data.userType, {
                    path: '/',
                    expires: exp
                });

                cookie.set("businessType", resp.data.data.businessType, {
                    path: '/',
                    expires: exp
                });

            }).catch((err: any) => {

                if (err && err.response && err.response.data && err.response.data.status === 401) {

                    logout();

                } else if (err && err.response && err.response.data) {

                    console.log(`Error! Could not get logged in user ${err.response.data}`)

                } else if (err && err.toString() === 'Error: Network Error') {

                    loader.popNetwork();

                } else if (err) {

                    console.log(`Error! Could not get logged in user ${err}`)

                }

            })

    }

    const getAPIKey = async (id?: string) => {

        let userId = id ? id : storage.getUserID();

        setLoading();

        await Axios.get(`${process.env.REACT_APP_API_URL}/users/apikey/${userId}`, storage.getConfigWithBearer())
            .then((resp) => {

                dispatch({
                    type: GET_APIKEY,
                    payload: resp.data.data
                });

            }).catch((err: any) => {

                if (err && err.response && err.response.data && err.response.data.status === 401) {

                    logout();

                } else if (err && err.response && err.response.data) {

                    console.log(`Error! Could not get user api key ${err.response.data}`)

                } else if (err && err.toString() === 'Error: Network Error') {

                    loader.popNetwork();

                } else if (err) {

                    console.log(`Error! Could not get user api key ${err}`)

                }

            })

    }

    const getUserDevices = async (id: string, data: IListQuery) => {

        const { limit, page, select, order } = data;

        const q = `limit=${limit ? limit.toString() : 20}&page=${page ? page.toString() : 1}&order=${order ? order : 'desc'}`;

        let userId = id ? id : storage.getUserID();

        setLoading();

        await Axios.get(`${process.env.REACT_APP_API_URL}/users/devices/${userId}`, storage.getConfigWithBearer())
            .then((resp) => {

                dispatch({
                    type: GET_DEVICES,
                    payload: resp.data.data
                });

            }).catch((err: any) => {

                if (err && err.response && err.response.data && err.response.data.status === 401) {

                    logout();

                } else if (err && err.response && err.response.data) {

                    console.log(`Error! Could not get user devices ${err.response.data}`)

                } else if (err && err.toString() === 'Error: Network Error') {

                    loader.popNetwork();

                } else if (err) {

                    console.log(`Error! Could not get user devices ${err}`)

                }

            })

    }

    const getCompliance = async (data: { id: string, type: 'kyb' | 'kyc' }) => {

        const { id, type } = data

        setLoading()

        await Axios.get(`${process.env.REACT_APP_API_URL}/users/${type}/${id}`, storage.getConfigWithBearer())
            .then((resp) => {

                if (type === 'kyb') {

                    dispatch({
                        type: GET_KYB_DATA,
                        payload: resp.data.data.kyb
                    });

                    dispatch({
                        type: GET_VERIFICATION_DATA,
                        payload: resp.data.data.verification
                    });


                    if (resp.data.data.kyb.industry) {
                        const result = helperService.getIndustries().find((x) => x.value === (resp.data.data.kyb.industry.toLowerCase()));
                        if (result && result.subIndustries && result.subIndustries.length > 0) {
                            setSubIndustries(helperService.sortData(result.subIndustries, 'name'))
                        }
                    }

                    if (resp.data.data.kyb.country) {
                        const result = helperService.readCountries().find((x) => x.name.toLowerCase() === resp.data.data.kyb.country.name.toLowerCase());
                        if (result && result.states && result.states.length > 0) {
                            setStates(helperService.sortData(result.states, 'name'))
                            if (resp.data.data.kyb.state) {
                                const _state: any = result.states.find((x: any) => x.name.toLowerCase() === resp.data.data.kyb.state.toLowerCase())
                                if (_state && _state.cities && _state.cities.length > 0) {
                                    setCities(helperService.sortData(_state.cities, 'name'))
                                }
                                if (_state && _state.subdivision && _state.subdivision.length > 0) {
                                    setLgas(helperService.sortData(_state.subdivision, 'name'))
                                }
                            }
                        }
                    }

                    if (resp.data.data.kyb.owners && resp.data.data.kyb.owners.length > 0) {
                        const countriesList = helperService.readCountries(); // Assuming this returns [{ name, states: [...] }]

                        const enrichedOwners = resp.data.data.kyb.owners.map((owner: any) => {
                            const countryMatch = owner.residentialAddress.country
                                ? countriesList.find(
                                    (c) => c.name.toLowerCase() === owner.residentialAddress.country.toLowerCase()
                                )
                                : null;

                            const matchedStates = countryMatch?.states || [];

                            const stateMatch = owner.residentialAddress.state
                                ? matchedStates.find(
                                    (s: any) => s.name.toLowerCase() === owner.residentialAddress.state.toLowerCase()
                                )
                                : null;

                            const matchedCities = stateMatch?.cities || [];
                            const matchedLgas = stateMatch?.subdivision || [];

                            return {
                                ...owner,
                                step: 0,
                                substep: 0,
                                countryStates: matchedStates,   // all states in the country
                                stateCities: matchedCities,     // all cities in the matched state
                                stateLgas: matchedLgas          // all lgas in the matched state
                            };
                        });

                        setOwnerItems(enrichedOwners);
                    }


                    if (resp.data.data.kyb.signatures && resp.data.data.kyb.signatures.length > 0) {
                        setSignatoryItems(resp.data.data.kyb.signatures);
                    }

                    // if (resp.data.data.kyb.owners && resp.data.data.kyb.owners.length > 0) {

                    //     setOwnerItems(resp.data.data.kyb.owners.map((director: any) => ({
                    //         ...director,
                    //         step: 0,
                    //         substep: 0,
                    //     })));
                    // }

                }

                if (type === 'kyc') {
                    dispatch({
                        type: GET_KYC_DATA,
                        payload: resp.data.data.kyc
                    });
                    dispatch({
                        type: GET_VERIFICATION_DATA,
                        payload: resp.data.data.verification
                    });
                }

            }).catch((err: any) => {

                if (err && err.response && err.response.data && err.response.data.status === 401) {

                    logout();

                } else if (err && err.response && err.response.data) {

                    console.log(`Error! Could not get compliance data ${err.response.data}`)

                } else if (err && err.toString() === 'Error: Network Error') {

                    loader.popNetwork();

                } else if (err) {

                    console.log(`Error! Could not get compliance data ${err}`)

                }

            })

    }

    const setLoading = () => {
        dispatch({
            type: SET_LOADING
        })
    }

    const unsetLoading = () => {
        dispatch({
            type: UNSET_LOADING,
        })
    }

    const setUserType = (n: string) => {

        dispatch({
            type: SET_USERTYPE,
            payload: n
        })

        if (n === 'superadmin') {
            dispatch({
                type: SET_IS_SUPER,
                payload: true
            })
            dispatch({
                type: SET_IS_ADMIN,
                payload: false
            })
        } else if (n === 'admin') {
            dispatch({
                type: SET_IS_SUPER,
                payload: false
            })
            dispatch({
                type: SET_IS_ADMIN,
                payload: true
            })
        } else {
            dispatch({
                type: SET_IS_SUPER,
                payload: false
            })
            dispatch({
                type: SET_IS_ADMIN,
                payload: false
            })
        }
    }

    const getUserType = () => {
        const ut = cookie.get('userType');
        return ut ? ut.toString() : '';
    }

    const isLoggedIn = (): boolean => {

        let flag = false;

        const ut = cookie.get('userType').toString();
        const tk = cookie.get('token').toString();

        if (storage.getUserID() && storage.getToken() && tk && ut) {
            flag = true;
        }

        return flag

    }

    const setSidebar = (a: boolean, l: string) => {
        dispatch({
            type: SET_SIDEBAR,
            payload: { active: a, label: l }
        })
    }

    const setUser = (data: any) => {
        dispatch({
            type: SET_USER,
            payload: data
        })
    }

    const setNotifications = (data: any) => {
        dispatch({
            type: SET_NOTIFICATIONS,
            payload: data
        })
    }

    const setVerification = (data: any) => {
        dispatch({
            type: GET_VERIFICATION_DATA,
            payload: data
        })
    }

    const setOwnerItems = (data: Array<IOwnerItem>) => {
        dispatch({
            type: SET_OWNER_ITEMS,
            payload: data
        })
    }

    const setSignatoryItems = (data: Array<ISignatoryItem>) => {
        dispatch({
            type: SET_SIGNATORY_ITEMS,
            payload: data
        })
    }

    const setCountries = (data: Array<any>) => {
        dispatch({
            type: GET_COUNTRIES,
            payload: data
        })
    }

    const setStates = (data: Array<any>) => {
        dispatch({
            type: GET_STATES,
            payload: data
        })
    }

    const setCities = (data: Array<any>) => {
        dispatch({
            type: GET_CITIES,
            payload: data
        })
    }

    const setIndustries = (data: Array<any>) => {
        dispatch({
            type: GET_INDUSTRIES,
            payload: data
        })
    }

    const setSubIndustries = (data: Array<any>) => {
        dispatch({
            type: GET_SUB_INDUSTRIES,
            payload: data
        })
    }

    const setLgas = (data: Array<any>) => {
        dispatch({
            type: GET_LGAS,
            payload: data
        })
    }

    return <UserContext.Provider
        value={{
            notifications: state.notifications,
            devices: state.devices,
            apikey: state.apikey,
            user: state.user,
            KYBData: state.KYBData,
            KYCData: state.KYCData,
            verification: state.verification,
            business: state.business,
            ownerItems: state.ownerItems,
            signatoryItems: state.ownerItems,
            countries: state.countries,
            states: state.states,
            cities: state.cities,
            lgas: state.lgas,
            ownerStates: state.ownerStates,
            ownerCities: state.ownerCities,
            ownerLgas: state.ownerLgas,
            industries: state.industries,
            subIndustries: state.subIndustries,
            sidebar: state.sidebar,
            userType: state.userType,
            isSuper: state.isSuper,
            isAdmin: state.isAdmin,
            loading: state.loading,
            getUser,
            getAPIKey,
            getUserDevices,
            setUserType,
            setSidebar,
            getUserType,
            getCompliance,
            setNotifications,
            setUser,
            setVerification,
            setOwnerItems,
            setSignatoryItems,
            setCountries,
            setStates,
            setCities,
            setLgas,
            setIndustries,
            setSubIndustries,
            unsetLoading,
            isLoggedIn
        }}
    >
        {props.children}

    </UserContext.Provider>

}

export default UserState